var Calendar = {
    locked: false,
    claimGhost: false,
    buyginIcon: false,
    buyingEffect: false,
    sendingCard: false,
    open: function (open_day) {
        if (!Calendar.locked) {
            Calendar.locked = true;
            var box = document.getElementById("box_" + open_day + "");
            var icon = document.getElementById("box_icon_" + open_day + "");
            Api.post("/calendar/open", { day: open_day }, function (r) {
                if (r.success) {
                    Alert.push([
                        {
                            type: "success",
                            text: "¡Tus premios han sido sumados a tu inventario!",
                            icon: "ok-circle",
                        },
                    ]);
                    box.removeAttribute("style");
                    box.setAttribute("style", "background-color:#26a65b;");
                    // icon.removeAttribute("class");
                    box.removeAttribute("onclick");

                    if (r.originalPrizeId == 0) {
                        icon.innerHTML = `
                            <div class="d-flex" style="align-items: center; flex-direction: column;">
                                <span class="glyphicons glyphicons-tree-deciduous"></span>
                                <p class="font-weight-bold" style="font-size: 12px;">3 días club Afro</p>
                            </div>
                        `;
                        //icon.setAttribute("class","glyphicons glyphicons-credit");
                    } else if (
                        r.originalPrizeId >= 3 &&
                        r.originalPrizeId <= 11
                    ) {
                        box.innerHTML =
                            '<img style="margin-left:5px;max-width:100px;" src="' +
                            r.prize +
                            '" />';
                    } else if (r.originalPrizeId == 1) {
                        icon.innerHTML = `
                             <div class="d-flex" style="align-items: center; flex-direction: column;">
                                <span class="glyphicons glyphicons-credit"></span>
                                <p class="font-weight-bold" style="font-size: 12px;">${r.amount} monedas web</p>
                            </div>
                        `;
                    } else if (r.originalPrizeId == 12) {
                        icon.innerHTML = `
                             <div class="d-flex" style="align-items: center; flex-direction: column;">
                                <span class="glyphicons glyphicons-ticket"></span>
                                <p class="font-weight-bold" style="font-size: 12px;">Pase</p>
                            </div>
                        `;
                        // icon.setAttribute("class","glyphicons glyphicons-tree-deciduous");
                    } else if (
                        r.originalPrizeId >= 11 &&
                        r.originalPrizeId <= 17
                    ) {
                        icon.remove();
                        box.innerHTML =
                            '<div class="achievement" rel="tooltip"  style="background-image:url(/images/hexagon_green.png), url(' +
                            r.prize +
                            ');width: 100px;height: 100px;margin-top: 4px;background-size: 100px 100px,100px 100px;"></div>';
                    }
                } else {
                    switch (r.error.identifier) {
                        case "gift_not_found":
                            Alert.push([
                                {
                                    type: "danger",
                                    text: "¡Oops! El regalo que intentas abrir no existe. Prueba con otro.",
                                    icon: "ok-circle",
                                },
                            ]);
                            break;
                        case "gift_not_available":
                            box.removeAttribute("style");
                            box.setAttribute("style", "filter:grayscale(100);");
                            icon.removeAttribute("class");
                            icon.setAttribute(
                                "class",
                                "glyphicons glyphicons-lock"
                            );
                            box.removeAttribute("onclick");

                            Alert.push([
                                {
                                    type: "danger",
                                    text: "¡Oops! Este regalo aún no está disponible.",
                                    icon: "triangle-alert",
                                },
                            ]);
                            break;
                        case "finish_time_expired":
                            box.removeAttribute("style");
                            box.setAttribute("style", "filter:grayscale(100);");
                            icon.removeAttribute("class");
                            icon.setAttribute(
                                "class",
                                "glyphicons glyphicons-lock"
                            );
                            box.removeAttribute("onclick");

                            Alert.push([
                                {
                                    type: "danger",
                                    text: "¡Oops! Este regalo ha expirado.",
                                    icon: "triangle-alert",
                                },
                            ]);
                            break;
                        case "already_opened_gift":
                            box.removeAttribute("style");
                            box.setAttribute(
                                "style",
                                "background-color:#26a65b;"
                            );
                            icon.removeAttribute("class");
                            icon.setAttribute(
                                "class",
                                "glyphicons glyphicons-ok"
                            );
                            box.removeAttribute("onclick");

                            Alert.push([
                                {
                                    type: "danger",
                                    text: "¡Oops! Yas has abierto anteriormente este regalo.",
                                    icon: "triangle-alert",
                                },
                            ]);
                            break;
                        case "ghost_required_failed":
                            Alert.push([
                                {
                                    type: "danger",
                                    text: "¡Oops! No tienes suficientes almas de fantasmas para intercambiar con la bruja.",
                                    icon: "triangle-alert",
                                },
                            ]);
                            break;
                    }
                }
                Calendar.locked = false;
            });
        }
    },

    ghost: function (token_ghost) {
        if (!Calendar.claimGhost) {
            Calendar.claimGhost = true;
            let container_box = document.getElementById(
                `etoken_${token_ghost}`
            );
            let icon = document.getElementById(`etoken_ghost_${token_ghost}`);
            Api.post("/ghosts/catch", { token: token_ghost }, function (i) {
                console.log(i);
                if (i.success) {
                    Alert.push([
                        {
                            type: "success",
                            text: "Se ha sumado un 1 alma de fantasma a tu cuenta. Visita https://habtium.es/hocuspocus para usarla.",
                            icon: "check",
                        },
                    ]);
                    container_box.remove();
                } else {
                    switch (i.error.identifier) {
                        case "already_taken_by_other_user":
                            Alert.push([
                                {
                                    type: "danger",
                                    text: "¡Oops! Alguien más ha pillado esta alma.",
                                    icon: "triangle-alert",
                                },
                            ]);
                            container_box.remove();
                            break;
                        case "energy_taken_by_another_user":
                            Alert.push([
                                {
                                    type: "danger",
                                    text: "¡Oops! Alguien más ha pillado esta alma.",
                                    icon: "triangle-alert",
                                },
                            ]);
                            container_box.remove();
                            break;
                        case "full_energy_capacity":
                            Alert.push([
                                {
                                    type: "danger",
                                    text: "¡Oops! Tienes tu recipiente de almas completo. No puedes obtener esta.",
                                    icon: "triangle-alert",
                                },
                            ]);
                            break;
                    }
                }
                Calendar.claimGhost = false;
            });
        }
    },
    buyIcon: function (id) {
        let btn = document.getElementById(`buy_icon_${id}`);
        if (!Calendar.buyginIcon) {
            Calendar.buyginIcon = true;
            Api.post("/calendar/buyIcon", { icon: id }, function (r) {
                if (r.success) {
                    btn.classList.remove("blue");
                    btn.classList.add("green");
                    btn.removeAttribute("onclick");
                    btn.innerHTML = `Adquirido <span class="glyphicons glyphicons-check"></span>`;
                    btn.setAttribute("disabled", true);
                    Alert.push([
                        {
                            type: "success",
                            text: "¡Bien! El ícono se ha sumado a tu cuenta..",
                            icon: "check",
                        },
                    ]);
                } else {
                    switch (r.error.identifier) {
                        case "effect_not_allowed":
                            Alert.push([
                                {
                                    type: "danger",
                                    text: "¡Oops! El ícono seleccionado no está disponible.",
                                    icon: "warning-sign",
                                },
                            ]);
                            break;
                        case "account_already_have_icon":
                            btn.classList.remove("blue");
                            btn.classList.add("green");
                            btn.removeAttribute("onclick");
                            btn.innerHTML = `Adquirido <span class="glyphicons glyphicons-check"></span>`;
                            btn.setAttribute("disabled", true);
                            Alert.push([
                                {
                                    type: "danger",
                                    text: "¡Oops! Ya posees este ícono.",
                                    icon: "warning-sign",
                                },
                            ]);
                            break;
                        case "coins_amount_min":
                            Alert.push([
                                {
                                    type: "danger",
                                    text: "¡Oops! No cuentas con las monedas suficientes.",
                                    icon: "warning-sign",
                                },
                            ]);
                            break;
                    }
                }
            });
            Calendar.buyginIcon = false;
        }
    },
    buyEffect: function (id) {
        let btn = document.getElementById(`buy_effect_${id}`);

        if (!Calendar.buyingEffect) {
            Calendar.buyingEffect = true;
            Api.post("/calendar/buy", { effect: id }, function (r) {
                if (r.success) {
                    Alert.push([
                        {
                            type: "success",
                            text: "¡Bien! Has adquirido el efecto con éxito.",
                            icon: "ok-circle",
                        },
                    ]);
                    btn.classList.remove("blue");
                    btn.classList.add("green");
                    btn.removeAttribute("onclick");
                    btn.innerHTML = `Adquirido <span class="glyphicons glyphicons-check"></span>`;
                    btn.setAttribute("disabled", true);
                } else {
                    switch (r.error.identifier) {
                        case "coins_amount_min":
                            Alert.push([
                                {
                                    type: "danger",
                                    text: "¡Oops! No cuentas con las suficientes monedas para comprar el efecto.",
                                    icon: "warning-sign",
                                },
                            ]);
                            break;
                        case "account_already_have_effect":
                            Alert.push([
                                {
                                    type: "danger",
                                    text: "¡Oops! Ya posees este efecto.",
                                    icon: "warning-sign",
                                },
                            ]);
                            btn.classList.remove("blue");
                            btn.classList.add("green");
                            btn.removeAttribute("onclick");
                            btn.innerHTML = `Adquirido <span class="glyphicons glyphicons-check"></span>`;
                            btn.setAttribute("disabled", true);
                            break;
                        case "effect_not_allowed":
                            Alert.push([
                                {
                                    type: "danger",
                                    text: "¡Oops! El efecto que intentas comprar no existe.",
                                    icon: "warning-sign",
                                },
                            ]);
                            break;
                    }
                }
            });
            Calendar.buyingEffect = false;
        }
    },
    postal: function () {
        let send_mode = document.getElementsByName("postal_type");
        let btn_send = document.getElementById("send_postal");
        let message_input = document.getElementById("message_card");
        let twitter_input = document.getElementById("twitterTo");
        let account_user = document.getElementById("accountTo");
        let container_postal = document.getElementById("postal_form");
        let box_container = document.getElementById("xmas_postal_box");
        var mode = false;
        if (send_mode[1].checked) {
            mode = true; // anonymous postal.
        }
        if (!Calendar.sendingCard) {
            Calendar.sendingCard = true;
            message_input.disabled = true;
            twitter_input.disabled = true;
            account_user.disabled = true;
            btn_send.disabled = true;
            Api.post(
                "/calendar/postal",
                {
                    message: message_input.value,
                    isAnonymous: mode ? "Sí" : "No",
                    twitterTo: twitter_input.value,
                    accountTo: account_user.value,
                },
                function (r) {
                    if (r.success) {
                        Alert.push([
                            {
                                type: "success",
                                text: "La postal navideña ha sido enviada con éxito.",
                                icon: "check",
                            },
                        ]);

                        container_postal.remove();
                        // append a success message
                        var message = `
                            <div class="body" style="display: flex;flex-direction: column; justify-content: center;align-items: center;">
                                <img loading="lazy" src="https://cdn.habtium.com/management/3aa286cc89b0.png" alt="Postales navideñas 2025" style="margin-bottom:10px;"/>
                                <div class="body text text-center" style="font-size: 12px;">
                                    ¡Bien hecho! Hemos enviado una solicitud de postal navideña a la Habtium Oficina Postal del Polo Norte. Si tu postal cumple con las normas establecidas, será enviada en breve. ¡Gracias por compartir la alegría navideña en Habtium!
                                </div>
                            </div>
                        `;
                        // dont replace innerHTML, just append
                        box_container.innerHTML += message;
                        Calendar.sendingCard = false;
                    } else {
                        switch (r.error.identifier) {
                            case "message_is_empty":
                                Alert.push([
                                    {
                                        type: "danger",
                                        text: "¡Oops! El texto de la postal está vacío.",
                                        icon: "triangle-empty-alert",
                                    },
                                ]);
                                break;
                            case "twitterTO_required":
                                Alert.push([
                                    {
                                        type: "danger",
                                        text: "¡Oops! Debes indicar el twitter de la cuenta.",
                                        icon: "triangle-empty-alert",
                                    },
                                ]);
                                break;
                            case "card_limitation_time":
                                Alert.push([
                                    {
                                        type: "danger",
                                        text: "¡Oops! Debe haber cinco minutos entre cada envío de postal navideña.",
                                        icon: "triangle-empty-alert",
                                    },
                                ]);
                                container_postal.remove();
                                // append a wait message
                                var message = `
                                    <div class="body" style="display: flex;flex-direction: column; justify-content: center;align-items: center;">
                                        <img loading="lazy" src="https://cdn.habtium.com/management/03903d98d22c.png" alt="Postales navideñas 2025" style="margin-bottom:10px;"/>
                                        <div class="body text text-center" style="font-size: 12px;">
                                            Ya has enviado una postal navideña recientemente. Podrás enviar otra postal en unos minutos.
                                        </div>
                                    </div>
                                `;
                                // dont replace innerHTML, just append
                                box_container.innerHTML += message;
                                break;
                        }
                        Calendar.sendingCard = false;
                    }
                }
            );
        } else {
            Alert.push([
                {
                    type: "danger",
                    text: "¡Oops! Estamos enviando una postal navideña. Espera que se complete este envío primero.",
                    icon: "triangle-empty-alert",
                },
            ]);
        }
        btn_send.disabled = true;
        //console.log("Sending postal by this mode: ", mode);
    },
};
